module.exports = __webpack_public_path__ + "components/t-shirt-comp/static/Playa-El-Palmar-a9fdad75c3693d9a89bb1cca1e8f4abd.jpg";